// Competition form constants
export const COMPETITION_TYPES = ['Local', 'Regional', 'Area/State', 'National', 'International', 'World', 'Invitational'];
export const STATUS_OPTIONS = ['Draft', 'Planning', 'In Progress', 'Open for Entries', 'Entries Closed', 'Completed'];

export const emptyForm = {
  name: '',
  short_name: '',
  sub_competition_name: '',
  host_organisation_id: '',
  competition_owner_id: '',
  venue_id: '',
  competition_type: 'Local',
  start_date: '',
  end_date: '',
  registration_deadline: '',
  status: 'Draft',
  schedule_id: '',
  sub_competition_schedule_id: '',
  figure_events_included: false,
  artistic_events_included: true,
  // Fee structure
  team_fee_type: 'standard_individual',
  fee_competitive_base: '',
  fee_competitive_per_event: '',
  fee_competitive_max: '',
  fee_team_skater_base: '',
  fee_team_skater_per_event: '',
  fee_team_skater_max: '',
  fee_team_base: '',
  fee_beginner_base: '',
  fee_beginner_per_event: '',
  fee_beginner_max: '',
  fee_other_type: '',
  fee_other_base: '',
  fee_other_per_event: '',
  fee_other_max: '',
  // Registration information
  music_email: '',
  music_submission_deadline: '',
  bank_account: '',
  bank_account_name: '',
  bank_account_confirmed: false,
  registration_instructions: '',
  public_results: true,
  live_streaming: false,
  special_requirements: '',
  // Feb 2026 — Area/State NZ Champs prompt for entry forms.
  nz_champs_country: '',
  nz_champs_region_city: ''
};

// Helper functions
export const getStatusColor = (status) => {
  switch(status) {
    case 'Draft': return 'bg-gray-100 text-gray-800';
    case 'Planning': return 'bg-blue-100 text-blue-800';
    case 'In Progress': return 'bg-yellow-100 text-yellow-800';
    case 'Open for Entries': return 'bg-green-100 text-green-800';
    case 'Entries Closed': return 'bg-orange-100 text-orange-800';
    case 'Completed': return 'bg-purple-100 text-purple-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const formatDateRange = (startDate, endDate) => {
  if (!startDate) return 'No date set';
  const start = new Date(startDate).toLocaleDateString('en-NZ', { day: 'numeric', month: 'long', year: 'numeric' });
  if (!endDate) return start;
  const startObj = new Date(startDate);
  const endObj = new Date(endDate);
  const sameDay = startObj.getDate() === endObj.getDate() && startObj.getMonth() === endObj.getMonth() && startObj.getFullYear() === endObj.getFullYear();
  if (sameDay) return start;
  const end = new Date(endDate).toLocaleDateString('en-NZ', { day: 'numeric', month: 'long', year: 'numeric' });
  if (startObj.getMonth() === endObj.getMonth() && startObj.getFullYear() === endObj.getFullYear()) {
    return `${startObj.getDate()} - ${endObj.getDate()} ${endObj.toLocaleDateString('en-NZ', { month: 'long', year: 'numeric' })}`;
  }
  return `${start} - ${end}`;
};
